export default __webpack_public_path__ + "static/media/fraud-scam-stepper-description-img.8e22ca7e.png";